import React, { useState, useEffect, useMemo, useCallback  } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import  ActionCenter  from "./ActionCenter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  X,
  UserPlus,
  Loader2,
  MapPin,
  Layers,
  CheckCircle2,
  Circle,
  TruckIcon,
  Trash2,
  Package,
  Plus,          
  CheckCircle,
  Inbox,
  Building,
  Phone,
  Truck,
  Timer,
  DollarSign,
   Clock,
} from "lucide-react";
import { faTruck ,faTrash ,faTimes,faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RenderRFQStepContent from './RenderRFQStepContent'
import ExtendTimePopup from '../../RFQs/ExtendTimePopup';
import { decryptData } from "../../../utils/storageCrypto";
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../../Messages/Messages';


/* ================= SAMPLE DATA ================= */
const deliveryShipments = [
  {
    supplierName: "Dwaraka Enterprises",
    distance: "4.5 km",
    items: [
      { name: "Item 1", qty: 2, weight: "200 kg" },
      { name: "Item 2", qty: 3, weight: "300 kg" },
    ],
  },
  {
    supplierName: "Krishna Enterprises",
    distance: "2 km",
    items: [
      { name: "Item 3", qty: 1, weight: "150 kg" },
      { name: "Item 4", qty: 2, weight: "250 kg" },
    ],
  },
//   {
//     supplierName: "Ratnagiri Enterprises",
//     distance: "6 km",
//     items: [{ name: "Item 5", qty: 4, weight: "600 kg" }],
//   },
];


const steps = [
  "RFQ Placed",
  "Supplier Responses",
  "Delivery Shipments",
  "Awarded",
  "Customer Payments",
  "Order Placed",
];

const calculateRemainingTime = (time_expired_at) => {
  if (!time_expired_at) return "--";

  const expiry = new Date(time_expired_at).getTime();
  const now = Date.now();
  const diff = expiry - now;

  if (diff <= 0) return "Time Completed";

  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return `${minutes}m ${seconds}s`;
};


const getUrgencyIndicator = (countdown) => {
  try {
    if (!countdown || countdown === "--" || countdown === "Time Completed") {
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }

    // ⏱ Extract minutes + seconds from countdown (e.g., "6m 16s")
    const match = countdown.match(/(\d+)m\s*(\d*)s?/);
    if (!match) {
      // Invalid format
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }

    const minutesLeft = parseInt(match[1]) || 0;
    const secondsLeft = parseInt(match[2]) || 0;
    const totalSecondsLeft = minutesLeft * 60 + secondsLeft;

    // 🔵🟡🔴 Color logic based on absolute remaining time
    if (totalSecondsLeft > 1200) {  // More than 20 minutes
      return <span className="h-3 w-3 rounded-full bg-blue-500 text-center" />;
    } else if (totalSecondsLeft > 600) {  // 10-20 minutes
      return <span className="h-3 w-3 rounded-full bg-yellow-500 animate-pulse text-center" />;
    } else if (totalSecondsLeft > 0) {  // Less than 10 minutes
      return <span className="h-3 w-3 rounded-full bg-red-500 animate-pulse text-center" />;
    } else {
      // Expired or 0 time left
      return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
    }
  } catch (error) {
    console.error('Error in getUrgencyIndicator:', error);
    return <span className="h-3 w-3 rounded-full bg-gray-400 text-center" />;
  }
};
/* ================= MAIN COMPONENT ================= */
const RFQFullfillmentFlow = () => {
  const navigate = useNavigate();
  const location = useLocation();
const rawRfqId = location.state?.rfq_id || location.state?._id;

const rfqId = typeof rawRfqId === "string"
  ? rawRfqId.replace(/^"+|"+$/g, "")
  : rawRfqId;
  const [activeStep, setActiveStep] = useState(1);
   const [showPopup, setShowPopup] = useState(false);
const [supplierResponsesPopupOpen, setSupplierResponsesPopupOpen] = useState(false);

  const [coinsToGive, setCoinsToGive] = useState('');
const [crediting, setCrediting] = useState(false);
const [assignPopupOpen, setAssignPopupOpen] = useState(false);
const [assignLoading, setAssignLoading] = useState(false);          
const [suppliers, setSuppliers] = useState([]);                     
const [selectedSuppliers, setSelectedSuppliers] = useState([]); 

  const [loading, setLoading] = useState(false);
  const [finalRfqData, setFinalRfqData] = useState(null);
  const [rfqLoading, setRfqLoading] = useState(false);
  const [RFQNumber, setRFQNumber] = useState('')
  const [rfqItemResponses, setRFQItemResponses] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [supplierResponses, setSupplierResponses] = useState([]);
  const [responsesLoading, setResponsesLoading] = useState(false);
  // 🔹 Item → Supplier selection map
const [selection, setSelection] = useState({});
  const [rfqItems, setRFQItems] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [rfqSummary, setRfqSummary] = useState(null);
  const [PCData, setPCData] = useState([])
const [groups, setGroups] = useState([]);
const [suppliersData, setSuppliersData] = useState(suppliers || []);
const [productCategories,setProductCategories] = useState([]) 
const [newSuppliers, setNewSuppliers]= useState([])            
const [showCreditResult, setShowCreditResult] = useState(false);
const [creditResult, setCreditResult] = useState({ success: false, message: '' });
const [paymentDetails, setPaymentDetails] = useState(null);
const [showExtendPopup, setShowExtendPopup] = useState(false);
const [elapsedTime, setElapsedTime] = useState("");
const [isRefreshing, setIsRefreshing] = useState(false);
const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
const [groupToDelete, setGroupToDelete] = useState(null);
const [isStepLoading, setIsStepLoading] = useState(false);
const [selectedItemId, setSelectedItemId] = useState(null);
const [filteredSuppliers, setFilteredSuppliers] = useState([]);
const [refreshTrigger, setRefreshTrigger] = useState(0);
const [showPopupMessages, setShowPopupMessages] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
const [selectedAlternatives, setSelectedAlternatives] = useState([]);
  const onPaymentSuccess = (msg) => {
  setPopupType('200or201');
  setPopupMessage(msg);
  setShowPopupMessages(true);
  
};
const [fareLoading, setFareLoading] = useState(false);



 function chooseVehicle(weight) {
  return vehicles.find(v => weight <= v.maxWeight) || vehicles[vehicles.length - 1];
}

const calculateElapsedTime = (startTime) => {
  if (!startTime) return "0m 0s";

  const diff = Date.now() - new Date(startTime).getTime();
  if (diff <= 0) return "0m 0s";

  const m = Math.floor(diff / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  return `${m}m ${s}s`;
};

// 🔹 Group RFQ items by category (derived data)
useEffect(() => {
  if (!rfqItems.length) return;

  const categoryMap = {};

  rfqItems.forEach(item => {
    const categoryId = item.item_category_id;
    if (!categoryId) return;

    if (!categoryMap[categoryId]) {
      categoryMap[categoryId] = {
        product_category_id: categoryId,
        product_category_name: item.item_category_name || "Uncategorized",
        items: []
      };
    }

    categoryMap[categoryId].items.push(item);
  });

  setProductCategories(Object.values(categoryMap));
}, [rfqItems]);

useEffect(() => {
  if (!rfqId) return;
  getCustomerRfqdetails(rfqId);
}, [rfqId]);
// 🔹 Helpers

/* const isCategoryFullySelected = (categoryItems, supplierId) => {
  return categoryItems.every(
    item => selection[item.item_id] === supplierId
  );
}; */

const isCategoryFullySelected = (categoryItems, supplierId) => {
  return categoryItems.every(
    item => selection[item.item_id]?.[supplierId]
  );
};

useEffect(() => {
  const startTime =
    customerInfo?.rfq_created_at || finalRfqData?.rfq_created_at;

  if (!startTime) return;

  // set immediately
  setElapsedTime(calculateElapsedTime(startTime));

  const i = setInterval(() => {
    setElapsedTime(calculateElapsedTime(startTime));
  }, 1000);

  return () => clearInterval(i);
}, [customerInfo?.rfq_created_at, finalRfqData?.rfq_created_at]);


// 🔥 NEW: EXACT EXPIRY REFRESH (Doesn't disturb elapsedTime)
useEffect(() => {
  if (!finalRfqData) return;

  // Get expiry time based on status
  const expiryTime = finalRfqData.status === "Waiting For Best Prices" 
    ? finalRfqData.waiting_time_expired_at 
    : finalRfqData.payment_time_expired_at;

  if (!expiryTime) return;

  const expiryMs = new Date(expiryTime).getTime();
  const nowMs = Date.now();
  const delayMs = expiryMs - nowMs;

  console.log(`⏰ Auto-refresh in ${Math.round(delayMs/1000)}s`);

  if (delayMs <= 0) {
    // Already expired
    triggerLeftRefresh();
    return;
  }

  // 🔥 EXACT TIME REFRESH
  const timeout = setTimeout(async () => {
    console.log("⏰ EXPIRY REACHED → Refreshing...");
    await triggerLeftRefresh();
  }, delayMs);

  return () => clearTimeout(timeout);
}, [finalRfqData?.status, finalRfqData?.waiting_time_expired_at, finalRfqData?.payment_time_expired_at]);

/* const toggleCategorySelection = (categoryItems, supplierId, supplierItems = []) => {
  setSelection(prev => {
    const updated = { ...prev };
    const fullySelected = isCategoryFullySelected(categoryItems, supplierId);

    // Build a fast lookup for supplier items
    const supplierItemMap = new Set(
      supplierItems.map(i => i.item_id)
    );

    categoryItems.forEach(item => {
      // Skip items not supplied by this supplier
      if (!supplierItemMap.has(item.item_id)) return;

      if (fullySelected) {
        // Deselect only if currently selected for this supplier
        if (updated[item.item_id] === supplierId) {
          delete updated[item.item_id];
        }
      } else {
        // Select item for this supplier
        updated[item.item_id] = supplierId;
      }
    });

    return updated;
  });
}; */

const toggleCategorySelection = (categoryItems, supplierId, supplierItems = []) => {
  setSelection(prev => {

    const updated = { ...prev };

    // Build fast lookup of supplier items
    const supplierItemMap = new Map(
      supplierItems.map(i => [i.item_id, i])
    );

    // Only items this supplier actually supplies and not not_available
    const validItems = categoryItems.filter(item => {
      const res = supplierItemMap.get(item.item_id);
      return res && !res.not_available;
    });

    // 🔥 Count how many are selected
    const selectedCount = validItems.filter(
      item => prev[item.item_id]?.[supplierId]
    ).length;

    const shouldDeselect = selectedCount === validItems.length;

    validItems.forEach(item => {

      if (!updated[item.item_id]) {
        updated[item.item_id] = {};
      }

      if (shouldDeselect) {
        // ✅ DESELECT
        delete updated[item.item_id][supplierId];

        if (Object.keys(updated[item.item_id]).length === 0) {
          delete updated[item.item_id];
        }

      } else {
        // ✅ SELECT
        updated[item.item_id][supplierId] = true;
      }
    });

    return updated;
  });
};


useEffect(() => {
    getCustomerRFQInfo(rfqId);
    getRFQItemResponseDetails(rfqId);
    fetchAllRFQSummary(rfqId);
  }, [/* rfqId */]);


  const onOpenAssignSupplier = () => {
  setAssignPopupOpen(true);
};

  useEffect(() => {
    if (!finalRfqData) return;
    //console.log("finalRfqData changed:::",finalRfqData)
     if(finalRfqData.status === 'Order Placed Sucessfully' || finalRfqData.status === 'Completed'){
      setActiveStep(6);
     }else if(finalRfqData.status === 'Final Price Received'){
      setActiveStep(4);
      }else{
      setActiveStep(1);
      }
  }, [finalRfqData]);

  const triggerLeftRefresh = async () => {
  try {
    setIsRefreshing(true);

    // 🔁 same APIs which should reload left side
    await Promise.all([
      getCustomerRFQInfo(rfqId),
      getRFQItemResponseDetails(rfqId),
      fetchAllRFQSummary(rfqId),
      getCustomerRfqdetails(rfqId)
    ]);
     setTimeout(() => {
      setIsRefreshing(false);
    }, 800);

  } catch (e) {
    console.error("Refresh failed", e);
  } finally {
    setIsRefreshing(false);
  }
};

useEffect(() => {
  if (activeStep === null) return;

  setIsStepLoading(true);

  const timer = setTimeout(() => {
    setIsStepLoading(false);
  }, 400); // loader time

  return () => clearTimeout(timer);
}, [activeStep]);

const closePopup = () => {
    setShowPopupMessages(false);
  };
  
  const Retry = async () => {
    setIsLoading(true); 
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); 
      }
      setIsLoading(false); 
    }, 5000); 
    setShowPopupMessages(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopupMessages(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };


 
// 🔹 Fetch RFQ item response details
const getRFQItemResponseDetails = async (rfqId) => {
  try {
    setRfqLoading(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    if (!token) {
      console.error("Authentication required. Please log in again.");
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-item-response-details?RFQId=${
        rfqId
      }`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const result = await response.json();
    if (result.success) {
      console.log(result.data)
      setRFQItemResponses(result.data);
      // update RFQNumber if available in response
      if (result.data && result.data.rfq_number) setRFQNumber(result.data.rfq_number);
    } else {
      console.error("Failed to fetch RFQ item response details:", result.message);
      setRFQItemResponses([]);
    }
  } catch (error) {
    console.error("Error fetching RFQ item response details:", error);
    setRFQItemResponses([]);
  } finally {
    setRfqLoading(false);
  }
};

// 🔹 Fetch Customer RFQ Info API
const getCustomerRFQInfo = async (rfqId) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    if (!token) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-customer-rfq-info?RFQId=${rfqId}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", "x-token": token },
      }
    );

   const result = await response.json();
   console.log("result customer info:",result);
    if (result.success) {
      setCustomerInfo(result.data);
      setSelectedRFQ({rfq_number:result.data.rfq_number,
      status:result.data.status,
      id:rfqId,
      rfq_created_at:result.data.rfq_created_at,
      _id:rfqId
      });
    } else {
      setCustomerInfo(null);
    }
  } catch (err) {
    console.error("Error fetching customer RFQ info:", err);
    setCustomerInfo(null);
  } finally {
  }
}; 
const [shipmentBlocks, setShipmentBlocks] = useState([
  {
    id: 1,
    shipments: deliveryShipments, // existing data
  },
]);

const addDeliveryShipment = () => {
  setShipmentBlocks(prev => [
    ...prev,
    {
      id: prev.length + 1,
      shipments: deliveryShipments, // same data
    },
  ]);
};

const removeDeliveryShipment = (blockIndex) => {
  setShipmentBlocks(prev =>
    prev.filter((_, index) => index !== blockIndex)
  );
};


const handleGiveCoins = async () => {
  if (!coinsToGive || Number(coinsToGive) <= 0) {
    console.error('Enter a valid BuildCoins amount');
    return;
  }
  // derive consumer id from fetched customer info if available
const consumerId =
  customerInfo?.data?.customer?._id ||
  customerInfo?.customer?._id;

if (!consumerId) {
  console.error('Consumer id not available', customerInfo);
  return;
}

  setCrediting(true);
  try {
    const rfqIdToUse =  rfqId;
    const res = await creditOrderCoins(consumerId, rfqIdToUse, Number(coinsToGive));
    const wasSuccessful = (res && (res.success === true || res.total_credited > 0));
    if (wasSuccessful) {
      setCreditResult({ success: true, message: res.message || `Credited ${res.total_credited || coinsToGive} BuildCoins` });
      setShowPopup(false);
      setCoinsToGive("");
    } else {
      setCreditResult({ success: false, message: (res && (res.message || JSON.stringify(res))) || 'Failed to credit BuildCoins' });
    }
    setShowCreditResult(true);
    setTimeout(() => setShowCreditResult(false), 3000);
  } catch (err) {
    console.error('Error during credit operation', err);
    setCreditResult({ success: false, message: err.message || 'Error during credit operation' });
    setShowCreditResult(true);
    setTimeout(() => setShowCreditResult(false), 3000);
  } finally {
    setCrediting(false);
  }
};

// API call for crediting BuildCoins (rewards service)
const creditOrderCoins = async (consumerId, rfqId, coinsAmount) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const headers = {
      'Content-Type': 'application/json',
      'x-token': token
    };

    const res = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}rewards/credit-order-coins`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ consumer_id: consumerId, order_id: rfqId, coins_amount: coinsAmount })
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
   
  } catch (error) {
    console.error('Error crediting coins:', error);
    return { success: false, message: error.message };
  }
};

const toggleSupplierSelection = (supplierId) => {
  setSelectedSuppliers(prev => 
    prev.includes(supplierId)
      ? prev.filter(id => id !== supplierId)
      : [...prev, supplierId]
  );
};

// Fetch suppliers when popup opens
 useEffect(() => {
  if (assignPopupOpen) fetchSuppliersForRFQ();
}, [assignPopupOpen]);

const fetchSuppliersForRFQ = async () => {
  try {
    if (!rfqId) {
      console.error("RFQ ID is missing. Cannot fetch suppliers.");
      return;
    }

    setAssignLoading(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);


    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-quick-buy-suppliers?rfq_id=${rfqId}`;

    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    const data = await res.json();
    console.log("Fetched suppliers data:", data);

    if (!data.success) {
      console.warn("Failed to fetch suppliers:", data.message);
      setNewSuppliers([]);
      return;
    }
    setNewSuppliers(data.suppliers || []);
  } catch (error) {
    console.error("Error fetching suppliers:", error);
    setNewSuppliers([]);
  } finally {
    setAssignLoading(false);
  }
}; 

const assignSelectedSuppliers = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);


    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/assign-suppliers-to-RFQ`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-token": token },
        body: JSON.stringify({
          rfq_id: rfqId,
          supplier_ids: selectedSuppliers,
        }),
      }
    );

    const data = await res.json();

    if (data.success) {
    setPopupType("200or201");
      setPopupMessage("Suppliers assigned successfully!");
      setShowPopupMessages(true);
      setTimeout(() => {
        setShowPopupMessages(false);
      }, 3000);
      const quotationId = customerInfo?.quotation_id || finalRfqData?.quotation_id;
      const responses = await handleGetSupplierResponses(quotationId);
      setSupplierResponses(responses);
      setAssignPopupOpen(false);
      setResponsesLoading(false);
      //refresh();
   } else {
      // ✅ popup error
      setPopupType("400");
      setPopupMessage(data.message || "Failed to assign suppliers");
      setShowPopupMessages(true);
    }
  } catch (e) {
    // ✅ server error popup
    setPopupType("500");
    setPopupMessage("Server error. Try again.");
    setShowPopupMessages(true);
  }
};

const isNextDisabled = useMemo(() => {
    // 🔹 NEW: Check if Response Time is Expired
  const isResponseExpired = finalRfqData?.waiting_time_expired_at 
    ? new Date(finalRfqData.waiting_time_expired_at) < new Date() 
    : false;

  if (activeStep === 2) {
    return Object.keys(selection).length === 0 || isResponseExpired;
  }

  if (activeStep === 3) {
    if (groups.length === 0) return true;

    const invalidDeliveryCost = groups.find(g => g.deliveryCharge === "");
    if (invalidDeliveryCost) return true;

    const invalidGroup = groups.find(
      g => g.deliveredByBrickbucket !== "true" && g.deliveredByBrickbucket !== "false"/* g.deliveredByBrickbucket === undefined || g.deliveredByBrickbucket === '' */
    );
    if (invalidGroup) return true;

    return false;
  }

  if (activeStep === 5) {
    return paymentDetails?.status !== 'paid';
  }

  return false;
}, [activeStep, selection, groups, paymentDetails,finalRfqData?.waiting_time_expired_at]);


const goNext = async () => {
  try {

if (activeStep === 2 && Object.keys(selection).length === 0) return;   
 if (activeStep === 5 && paymentDetails?.status !== 'paid') return;
    if (activeStep === 3) {
      // ✅ Validate before processing
    if (!rfqId) {
  setPopupType("400");
  setPopupMessage("RFQ ID not found. Please refresh and try again.");
  setShowPopupMessages(true);
  return;
}
      
    if (groups.length === 0) {
  setPopupType("400");
  setPopupMessage("Please create at least one delivery group");
  setShowPopupMessages(true);
  return;
}

      const invalidDeliveryCost = groups.find(
  g => g.deliveryCharge === ""
);

if (invalidDeliveryCost) {
  setPopupType("400");
  setPopupMessage("Delivery cost is required. Please enter a value or keep 0.");
  setShowPopupMessages(true);
  return;
}

      // NEW: Delivery Cost validation (each group lo required)
      // const invalidDeliveryCost = groups.find(g => !g.deliveryCharge || g.deliveryCharge === '' || isNaN(g.deliveryCharge));
      // if (invalidDeliveryCost) {
      //   toast.error("Please Select Delivery cost for all the groups.");
      //   return;
      // }

      // NEW: Vehicle dropdown validation (each group lo required)
      // const invalidVehicle = groups.find(g => !g.vehicleId || g.vehicleId === '' || g.vehicleId === 'Select');
      // if (invalidVehicle) {
      //   toast.error("Please select Vehicle for all groups from the dropdown.");
      //   return;
      // }

      // Existing: Delivered by Brickbucket validation
      const invalidGroup = groups.find(g => g.deliveredByBrickbucket !== "true" && g.deliveredByBrickbucket !== "false"/* g.deliveredByBrickbucket === undefined || g.deliveredByBrickbucket === '' */);
     if (invalidGroup) {
  setPopupType("400");
  setPopupMessage(
    "Delivered by Brickbucket is required. Please select Yes/No from dropdown."
  );
  setShowPopupMessages(true);
  return;
}

      // ✅ Prepare correct delivery groups structure
      const deliveryGroups = groups.map(g => ({
        groupId: g.groupId,
        vehicle_type: g.vehicleId || null,
        total_weight: groupWeight(g.suppliers),
       delivery_charges: Number(g.deliveryCharge || 0),
         is_delivered_by_brickbucket: g.deliveredByBrickbucket === "true",
        items: Object.values(g.suppliers).flatMap(s => s.items)
      }));

      
      // ✅ Call fixed API
      await startAwardProcess(deliveryGroups);
      
setPopupType("200or201");
setPopupMessage("Award processed successfully!");
setShowPopupMessages(true);
setTimeout(() => {
  setShowPopupMessages(false);
}, 3000);
    }

    setActiveStep(prev => Math.min(prev + 1, steps.length));
    if (activeStep === 6) {
     navigate('/bb/app/home', { state: {activeTab:'orders' } });
    }
  } catch (error) {
    console.error("goNext error:", error);
    // Stay on current step if error
  }
};



  const goPrev = () => {
    setActiveStep((prev) => Math.max(prev - 1, 1));
  };


  // 📦 Fetch Supplier Responses
  const handleGetSupplierResponses = async (quotation_id) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const res = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-requests-and-responces-of-supplier?quotation_id=${quotation_id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json", "x-token": token },
        }
      );
      const data = await res.json();
      console.log("Supplier responses data:", data);
      if (data.success && data.data.length > 0) return data.data;
      return [];
    } catch (error) {
      console.error("Error fetching supplier responses:", error);
      return [];
    }
  };

  // 👁 View Responses Popup
  const handleViewResponses = async (quotationIdOrRfq) => {
    setResponsesLoading(true);
    const quotationId =
      (typeof quotationIdOrRfq === "string" && quotationIdOrRfq) ||
      quotationIdOrRfq?.quotation_id ||
      customerInfo?.quotation_id ||
      finalRfqData?.quotation_id;

    const responses = await handleGetSupplierResponses(quotationId);

    setSupplierResponses(responses);
    setResponsesLoading(false);
  };

  const openSupplierResponsePopup = (itemId) => {
  setSelectedItemId(itemId);

  const matchedSuppliers = suppliers
    .filter(supplier =>
      supplier.response_items.some(r => String(r.item_id) === String(itemId))
    )
    .map(supplier => {
      const itemData = supplier.response_items.find(
        r => String(r.item_id) === String(itemId)
      );

      return {
        ...supplier,

        // 🔥 MATCH YOUR OLD UI STRUCTURE
        vendor: {
          company_name: supplier.company_name,
          name: supplier.name,
          mobile:supplier.mobile_number,
          address:supplier.address,
        },

        response_status: supplier.status,
        delivered_by: supplier.distanceKm + " km",
        time_expired_at: null, // keep empty if not available

        response_items: [
          {
            total_price:
      (itemData.proposed_price > 0
        ? itemData.proposed_price
        : itemData.requested_price) *
      (itemData.quantity || 1),
            status: itemData.item_status,
            items_count: supplier.response_items.length,
            item_id: itemData.item_id,
          },
        ],
      };
    });

  setFilteredSuppliers(matchedSuppliers);
  setSupplierResponsesPopupOpen(true);
};


  const fetchAllRFQSummary = async (rfqId) => {
  if (!rfqId) {
    throw new Error("rfqId is required");
  }
 const encryptedToken = sessionStorage.getItem('token');
 const token = decryptData(encryptedToken);

  const FetchURL = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-all-rfq-summary?rfq_id=${rfqId}`;
 
  try {
    const response = await fetch(FetchURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": token,
      },
    });

    const data = await response.json();
    console.log(data)
            setRfqSummary(data);
        setRFQItems(data.requested_items); // Assuming data contains items
        setSuppliers(data.supplier_responses); // Assuming data contains suppliers
        setVehicles(data.vehicles_data); // Assuming data contains vehicles
        setPCData(data.product_categorys)
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to fetch RFQ summary");
    }

    return data;
  } catch (error) {
    console.error("Error fetching RFQ summary:", error.message);
    throw error;
  }
};


  // Price matrix logic (unchanged from your code, but memoized for performance)
 const matrix = useMemo(() => {
  return rfqItems.map(item => {
    const prices = suppliers
      .map(supplier => {
        const supplierItem = supplier.response_items.find(
          i => i.item_id === item.item_id
        );

        if (!supplierItem) return null;

        const unitPrice =
          supplierItem.proposed_price > 0
            ? supplierItem.proposed_price
            : supplierItem.requested_price || 0;

        const quantity = item.quantity || 0;

        const total = unitPrice * quantity;
        const requested_item_id = supplierItem.requested_item_id;

        return {
          supplierId: supplier.vendor_id,
          unitPrice,
          quantity,
          total,
          requested_item_id
        };
      })
      .filter(Boolean);

    const totals = prices.map(p => p.total);

    return {
      item,
      prices,
      min: totals.length ? Math.min(...totals) : 0,
      max: totals.length ? Math.max(...totals) : 0,
    };
  });
}, [rfqItems, suppliers]);

const summary = useMemo(() => {
  let itemsTotal = 0;
  const supplierItemsMap = {};

  Object.entries(selection).forEach(([itemId, supplierMap]) => {
    // Find the selected supplier ID from the object { vendorId: true }
    const supplierId = Object.keys(supplierMap).find(key => supplierMap[key]);
    if (!supplierId) return;

    const item = rfqItems.find(i => i.item_id === itemId);
    const supplier = suppliers.find(s => s.vendor_id === supplierId);

    if (!item || !supplier) return;

    const supplierItem = supplier.response_items.find(
      si => si.item_id === item.item_id
    );

    if (!supplierItem) return;

    const unitPrice =
      supplierItem.proposed_price > 0
        ? supplierItem.proposed_price
        : supplierItem.requested_price || 0;

    const quantity = item.quantity || 0;
    const itemTotal = unitPrice * quantity;

    itemsTotal += itemTotal;

    if (!supplierItemsMap[supplierId]) {
      supplierItemsMap[supplierId] = [];
    }

    supplierItemsMap[supplierId].push({
      ...item,
      quantity,
      unitPrice,
      itemTotal,
    });
  });

  // Delivery Calculation (Optional: based on groups if available, else estimate)
  let deliveryTotal = 0;
  if (groups.length > 0) {
    deliveryTotal = groups.reduce((sum, g) => sum + Number(g.deliveryCharge || 0), 0);
  }

  const selectedCount = Object.keys(selection).length;
  const completionPercentage = rfqItems.length
    ? Math.round((selectedCount / rfqItems.length) * 100)
    : 0;
  
  const grandTotal = itemsTotal + deliveryTotal;

  return {
    itemsTotal,
    deliveryTotal,
    grandTotal,
    selectedCount,
    completionPercentage,
  };
}, [selection, rfqItems, suppliers, groups]);


const awardedItems = useMemo(() => {
  return Object.entries(selection).map(([itemId, supplierMap]) => {
    const supplierId = Object.keys(supplierMap).find(key => supplierMap[key]);
    const item = rfqItems.find(i => i.item_id === itemId);
    const supplier = suppliers.find(s => s.vendor_id === supplierId);

    if (!item || !supplier) return null;

    const supplierItem = supplier.response_items.find(
      si => si.item_id === item.item_id
    );
    
    const unitPrice =
      supplierItem?.proposed_price > 0
        ? supplierItem.proposed_price
        : supplierItem?.requested_price || 0;

    return {
      item_id: item.item_id,
      item_name: item.item_name,
      quantity: item.quantity,
      weightPerUnit: item.weightPerUnit || 0,
      supplierId: supplier.vendor_id,
      supplierName: supplier.company_name || supplier.name,
      unitPrice,
      totalWeight: item.quantity * (item.weightPerUnit || 0),
      is_alternative: !!supplierItem?.requested_item_id,
      requested_item_id: supplierItem?.requested_item_id || null,
      weight:item.weight,
      dimensions:item.dimensions
    };
  }).filter(Boolean);
}, [selection, rfqItems, suppliers]);

useEffect(() => {
  if (activeStep === 3 && groups.length === 0 && awardedItems.length > 0) {
    // Group items by supplier
    const suppliersMap = {};
    awardedItems.forEach(item => {
      if (!suppliersMap[item.supplierId]) {
        suppliersMap[item.supplierId] = {
          supplierId: item.supplierId,
          supplierName: item.supplierName,
          items: []
        };
      }
      suppliersMap[item.supplierId].items.push(item);
    });

    // Create initial group
    const initialGroup = {
      groupId: `DG-${Date.now()}`, // Unique ID
      suppliers: suppliersMap,
      vehicleId: vehicles?.[0]?.type || null,
      deliveryCharge: 0,
      deliveredByBrickbucket: "false"
    };

    setGroups([initialGroup]);
  }
}, [activeStep, awardedItems, vehicles, groups.length]);

useEffect(() => {
  if (activeStep === 4) {
    (async () => {
      setResponsesLoading(true);
      const quotationId = customerInfo?.quotation_id || finalRfqData?.quotation_id;
      const responses = await handleGetSupplierResponses(quotationId);
      getRFQItemResponseDetails(rfqId);
       //getCustomerRFQInfo(rfqId);
      setSupplierResponses(responses);
      setResponsesLoading(false);
    })();
  }
  if( activeStep === 5){
    //getCustomerRFQInfo(rfqId);
    getPaymentDetails(rfqId);
  }
  //console.log("activeStep changed:::",activeStep)
  if(activeStep === 6){
    getCustomerRfqdetails(rfqId)
  }
  fetchAllRFQSummary(rfqId);
}, [activeStep, customerInfo]);

const [countdown, setCountdown] = useState("--");

{/*useEffect(() => {
  if (!finalRfqData?.waiting_time_expired_at) {
    setCountdown("--");
    return;
  }
const ExpiredTime = finalRfqData.status === 'Waiting For Best Prices'?  finalRfqData.waiting_time_expired_at : finalRfqData.payment_time_expired_at;
  setCountdown(calculateRemainingTime(ExpiredTime));

  const interval = setInterval(() => {
    const ExpiredInterWellTime = finalRfqData.status === 'Waiting For Best Prices'?  finalRfqData.waiting_time_expired_at : finalRfqData.payment_time_expired_at;
    setCountdown(
      calculateRemainingTime(ExpiredInterWellTime)
    );
  }, 1000);

  return () => clearInterval(interval);
}, [finalRfqData?.waiting_time_expired_at]);*/}

useEffect(() => {
  if (!finalRfqData) {
    setCountdown("--");
    return;
  }

  // Decide which timer to use
  const expiryTime =
    finalRfqData.status === "Waiting For Best Prices"
      ? finalRfqData.waiting_time_expired_at
      : finalRfqData.payment_time_expired_at;

  if (!expiryTime) {
    setCountdown("--");
    return;
  }

  const expiredTime = new Date(expiryTime).getTime();

  const updateCountdown = () => {
    const now = Date.now();
    const diff = expiredTime - now;

    if (diff <= 0) {
      setCountdown("Time Completed");
      return false;
    }

    const mins = Math.floor(diff / 1000 / 60);
    const secs = Math.floor((diff / 1000) % 60);

    setCountdown(`${mins}m ${secs}s`);
    return true;
  };

  updateCountdown();

  const interval = setInterval(() => {
    const keepRunning = updateCountdown();
    if (!keepRunning) clearInterval(interval);
  }, 1000);

  return () => clearInterval(interval);
}, [
  finalRfqData?.status,                    // 🔥 stage change
  finalRfqData?.waiting_time_expired_at,   // RFQ extension
  finalRfqData?.payment_time_expired_at    // Payment extension
]);




//const urgency = getUrgencyIndicator(countdown);

const getCustomerRfqdetails = async () => {
    try {
      // Get user info

      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-by-id?RFQId=${rfqId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
       console.log('Fetched RFQ details after refresh:', data);
      //console.log('Fetched RFQ details:', data);
      setFinalRfqData(data.data);
    } catch (error) {
      console.error('Error fetching RFQ details:', error);
    } finally {
      setLoading(false);
    }
  };

const getPaymentDetails = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    if (!token) {
      console.error("Authentication required. Please log in again.");
      return;
    }
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/get-rfq-payment-details?rfq_id=${rfqId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    if (!response.ok) {
      console.error("Failed to fetch payment details");
    setPaymentDetails(null);
      return;
    }

    const data = await response.json();
    setPaymentDetails(data.data.paymentDetails || null);
  } catch (error) {
    console.error("Error fetching payment details:", error);
  }
};
 const handleExtendTime = () => {
  setShowExtendPopup(true);
};

const refresh = async () => {
 getCustomerRfqdetails(rfqId);  // Now awaited
  setRefreshTrigger(prev => prev + 1);
};

  const moveSupplier = (supplier, fromGroupId, toGroupId) => {
    if (!toGroupId || fromGroupId === toGroupId) return;

    setGroups(prev =>
      prev.map(group => {
        if (group.groupId === fromGroupId) {
          const suppliers = { ...group.suppliers };
          delete suppliers[supplier.supplierId];
          return { ...group, suppliers };
        }

        if (group.groupId === toGroupId) {
          const suppliers = { ...group.suppliers };

          suppliers[supplier.supplierId] = suppliers[supplier.supplierId]
            ? {
                ...suppliers[supplier.supplierId],
                items: [
                  ...suppliers[supplier.supplierId].items,
                  ...supplier.items
                ]
              }
            : { ...supplier };

          return { ...group, suppliers };
        }

        return group;
      })
    );
  };

  const groupWeight = suppliers =>
    Object.values(suppliers)
      .flatMap(s => s.items)
      .reduce((sum, i) => sum + Number(i.totalWeight || 0), 0);

const handleConfirm = () => {
  onConfirm(
    groups.map(g => ({
      groupId: g.groupId,
      vehicle_type: g.vehicleId,
      total_weight: groupWeight(g.suppliers),
      delivery_charge: Number(g.deliveryCharge || 0),
      items: Object.values(g.suppliers).flatMap(s => s.items)
    }))
  );
};

const moveItem = (item, fromGroupId, toGroupId) => {
  if (!toGroupId || fromGroupId === toGroupId) return;

  setGroups(prev =>
    prev.map(group => {
      // REMOVE item from source group
      if (group.groupId === fromGroupId) {
        const suppliers = { ...group.suppliers };
        const supplier = suppliers[item.supplierId];

        if (!supplier) return group;

        suppliers[item.supplierId] = {
          ...supplier,
          items: supplier.items.filter(i => i.item_id !== item.item_id),
        };

        // cleanup empty supplier
        if (suppliers[item.supplierId].items.length === 0) {
          delete suppliers[item.supplierId];
        }

        return { ...group, suppliers };
      }

      // ADD item to destination group
      if (group.groupId === toGroupId) {
        const suppliers = { ...group.suppliers };

        suppliers[item.supplierId] = suppliers[item.supplierId]
          ? {
              ...suppliers[item.supplierId],
              items: [...suppliers[item.supplierId].items, item],
            }
          : {
              supplierId: item.supplierId,
              supplierName: item.supplierName,
              items: [item],
            };

        return { ...group, suppliers };
      }

      return group;
    })
  );
};

useEffect(() => {
  if (awardedItems.length > 0) {
    // Initialize groups with REAL awardedItems
    const suppliers = {};
    awardedItems.forEach(item => {
      if (!suppliers[item.supplierId]) {
        suppliers[item.supplierId] = {
          supplierId: item.supplierId,
          supplierName: item.supplierName,
          items: []
        };
      }
      suppliers[item.supplierId].items.push(item);
    });
    setGroups([{
      groupId: "DG-1",
      suppliers,
      vehicleId:vehicles?.[0]?.type || null,
      deliveryCharge: 0,
      deliveredByBrickbucket: "false"
    }]);
  }
}, [ awardedItems]);

useEffect(() => {
  if (vehicles?.length > 0 && groups.length > 0) {
    setGroups(prev =>
      prev.map(g =>
        g.vehicleId
          ? g
          : { ...g, vehicleId: vehicles[0].type } 
      )
    );
  }
}, [vehicles]);


// Add this useCallback near your other state/effects
const addGroup = useCallback(() => {
  setGroups(prevGroups => {
    const newGroupId = `DG-${Date.now()}`;
    const newGroup = {
      groupId: newGroupId,
      suppliers: {},
      vehicleId: vehicles?.[0]?.type || null,
      deliveryCharge: 0,
      deliveredByBrickbucket: "false"
    };

    const newGroups = [...prevGroups, newGroup];
    
    setTimeout(() => {
      const newGroupElement = document.querySelector(`[data-group-id="${newGroupId}"]`);
      if (newGroupElement) {
        newGroupElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 150);
    
    return newGroups;
  });
}, [vehicles]);


// ✅ Add this function BEFORE your STEP-3 code
const startAwardProcess = async (deliveryGroups) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    
    // 🔥 YOUR WORKING ID FROM TOP OF FILE
    
    if (!rfqId) throw new Error("RFQ ID not found");

    const validDeliveryGroups = deliveryGroups.filter(g => g.items?.length > 0);
    if (validDeliveryGroups.length === 0) {
      throw new Error("No valid delivery groups with items");
    }

    const salesOrderItems = deliveryGroups.flatMap(g =>
      g.items.map(i => ({
        item_id: i.item_id,
        supplier_id: i.supplierId,
        quantity: Number(i.quantity || 0),
        unit_price: Number(i.unitPrice || 0),
        cost_price: Number( i.unitPrice || i.cost_price || 0),
      }))
    );



    const payload = {
      rfq_id: rfqId,  // ✅ THIS WORKS!
      salesorder_items: salesOrderItems,
      delivery_groups: deliveryGroups,
      alternative_products: selectedAlternatives,
    };

    console.log("payload:",payload);

    //console.log("Award Payload:", payload);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/manual-award-of-quickbuy-order`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(payload),
      }
    );

    const responseData = await response.json();
    console.log("Award Response:", responseData);
    
    if (response.ok && responseData.success) {
 setPopupType("200or201");
  setPopupMessage("RFQ Awarded Successfully! ✅");
  setShowPopupMessages(true);

   await triggerLeftRefresh();  

  setTimeout(() => {
    setShowPopupMessages(false);
  }, 3000);  
      return responseData;
    } else {
      throw new Error(responseData?.message || `Status: ${response.status}`);
    }
  } catch (error) {
    console.error("❌ Award Error:", error);
 setPopupType("500");
  setPopupMessage(error.message || "Something went wrong");
  setShowPopupMessages(true);
      throw error;
  }
};

const handleSelectActiveStep = (step) => {
if (step === 3 && Object.keys(selection).length === 0) return;
 if (step === 4) {
   if (finalRfqData?.status !== 'Final Price Received') return;
    if (!rfqId) return;
    if (groups.length === 0) return;
    const invalidDeliveryCost = groups.find(g => g.deliveryCharge === "");
    if (invalidDeliveryCost) return;
    const invalidGroup = groups.find(g => g.deliveredByBrickbucket !== "true" && g.deliveredByBrickbucket !== "false" /* g.deliveredByBrickbucket === undefined || g.deliveredByBrickbucket === '' */);
    if (invalidGroup) return;
  }

  if (step === 5) {
    // Step-3 check
    if (Object.keys(selection).length === 0) return;

    // Step-4 check
    if (finalRfqData?.status !== 'Final Price Received') return;
    if (!rfqId) return;
    if (groups.length === 0) return;

    const invalidDeliveryCost = groups.find(g => g.deliveryCharge === "");
    if (invalidDeliveryCost) return;

    const invalidGroup = groups.find(
      g => g.deliveredByBrickbucket !== "true" && g.deliveredByBrickbucket !== "false" /* g.deliveredByBrickbucket === undefined || g.deliveredByBrickbucket === '' */
    );
    if (invalidGroup) return;
  }
  
  if (step === 6 && paymentDetails?.status !== 'paid') return;

  if (finalRfqData?.status === 'Order Placed Sucessfully') {
    if (step >= 6) {
      setActiveStep(6);
    }
  } else if (finalRfqData?.status === 'Final Price Received') {
    if (step > 4) {
      setActiveStep(step);
    } else if (step <= 4) {
      setActiveStep(4);
    }
  } else {
    setActiveStep(step);
  }
};


const unassignedSuppliers = useMemo(() => {
  const assignedIds = new Set(suppliers.map(s => s.vendor_id));
  return newSuppliers.filter(s => !assignedIds.has(s.vendor_id));
}, [newSuppliers, suppliers]);

  // Define onConfirm function
  const onConfirm = (data) => {
    // Handle the confirmation logic here, e.g., send to API or update state
    // You can add your API call or state update logic here
  };

  const getStatusLabel = (status) => {
  if (status === "Respond Now") return "Waiting for Response";
  if (status === "Counter Offer") return "Counter Offered";
  return status;
};

const getStatusColor = (status) => {
  switch (status) {
    case "Accepted":
      return "bg-blue-100 text-blue-800";
    case "Awarded":
      return "bg-green-100 text-green-800";
    case "Waiting for Response":
    case "Respond Now":
      return "bg-yellow-100 text-yellow-800";
    case "Counter Offer":
      return "bg-orange-100 text-orange-800";
    default:
      return "bg-red-100 text-red-800";
  }
};

  return (
/*     <div className="p-6 bg-gray-100 min-h-screen flex flex-col">
 */   
<div className="flex h-screen w-full overflow-hidden bg-white">
<div className="relative flex-1 h-full flex flex-col min-w-0"> 
    {isRefreshing ? (
        <div className=" flex w-full  justify-center  bg-opacity-50 ">
    <div className=" flex space-x-2 w-full justify-center items-center h-20  ">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
    </div>
  </div>
    ) : (
       <>

<div className="flex-1 overflow-y-auto pb-24">        
        
      <div className="sticky top-0 z-50 border border-gray-200 shadow-sm rounded-md px-6 mx-4 py-3 pb-4 mt-4 bg-gray-50">
  <div className="flex items-center text-sm text-gray-700">

     <div className="mr-6 cursor-pointer ">
        <FontAwesomeIcon
          icon={faArrowLeft}
          className="text-gray-700 text-md hover:text-black"
          onClick={() => navigate("/bb/app/home", { state: { activeTab: "rfqs" } })} 
        />
      </div>

    {/* RFQ NUMBER */}
    <div className="pr-6">
      <p className="text-xs text-gray-500">RFQ Number</p>
      <p className="font-semibold mt-1">
        {customerInfo?.rfq_number || RFQNumber || "--"}
      </p>
    </div>

    {/* VERTICAL LINE */}
    <div className="h-10 w-px bg-gray-200 mx-6" />

    {/* CUSTOMER */}
    <div className="pr-4">
      <p className="text-xs text-gray-500">Customer</p>
      <p className="font-semibold mt-1">
        {customerInfo?.customer?.name || "--"}
      </p>
      <p className="text-xs text-gray-500 mt-0.5">
        {customerInfo?.customer?.mobile || "--"}
      </p>
    </div>

    {/* VERTICAL LINE */}
    <div className="h-10 w-px bg-gray-200 mx-6" />

    {/* CREATED AT */}
    <div className="pr-4">
      <p className="text-xs text-gray-500">Created at</p>
      <p className="font-semibold mt-1">
        {customerInfo?.rfq_created_at
          ? new Date(customerInfo.rfq_created_at).toLocaleString("en-IN", {
              year: "numeric",
              month: "short",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            })
          : "--"}
      </p>
    </div>

    {/* VERTICAL LINE */}
    <div className="h-10 w-px bg-gray-200 mx-6" />

    {/* COUNTDOWN / EXPIRED / EXTEND (UNCHANGED) */}
    {(finalRfqData?.status === "Waiting For Best Prices" ||
      finalRfqData?.status === "Final Price Received") && (
      <>
        {countdown === "Time Completed" ? (
          <div className="flex flex-col items-center gap-1">
            <span className="text-gray-400 text-xs">⏱ Time Expired</span>
            <button
              onClick={handleExtendTime}
              className="text-blue-600 text-xs underline"
            >
              {finalRfqData?.status === "Waiting For Best Prices"
                ? "Extend Waiting Time"
                : "Extend Payment Time"}
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-1">
            <span className="font-medium">{countdown}</span>
            <button
              onClick={handleExtendTime}
              className="text-blue-600 text-xs underline"
            >
              {finalRfqData?.status === "Waiting For Best Prices"
                ? "Extend Waiting Time"
                : "Extend Payment Time"}
            </button>
          </div>
        )}
      </>
    )}


{/* ASSIGN SUPPLIER */}
{activeStep  === 1 && (
  <>
    <div className="h-10 w-px bg-gray-200 mx-6" />

    <div className="pr-4 flex flex-col justify-center">
      <button
        onClick={onOpenAssignSupplier}
        className="mt-1 text-blue-600 text-sm font-medium underline hover:text-blue-700"
      >
        + Assign Supplier
      </button>
    </div>
  </>
)}

   {/* <div className="flex items-start ml-6">
  <div className="h-10 w-px bg-gray-300 mx-4" />

  <div className="flex flex-col leading-tight">
    <span className="text-[11px] text-gray-500 mb-1" >
      Elapsed Time
    </span>
    <span className="text-sm text-gray-700 font-semibold text-center">
      {elapsedTime}
    </span>
  </div>
</div> */}

  </div>
</div>


        {/* ================= STEPPER ================= */}
<div className="sticky top-[94px] z-40 bg-white relative mb-4 mt-4">

  {/* GRAY CONNECTOR LINE */}
  <div
    className="absolute top-6 h-[2px] bg-gray-300 z-0"
    style={{
      left: `${50 / steps.length}%`,
      right: `${50 / steps.length}%`,
      width:
        steps.length > 1
          ? `calc(100% - ${100 / steps.length}%)`
          : "0%",
    }}
  />

  {/* BLUE PROGRESS LINE – FIXED */}
  <div
    className="absolute top-6 h-[2px] bg-green-500 z-10 transition-all duration-500 ease-in-out"
    style={{
      left: `${50 / steps.length}%`,
      width:
        activeStep <= 1
          ? "0%"
          : `calc(
              ((100% - ${100 / steps.length}%)
              / ${steps.length - 1})
              * ${activeStep - 1}
            )`,
    }}
  />

  {/* STEPS */}
  <div className="flex justify-between relative z-20">
    {steps.map((label, index) => {
      const step = index + 1;
      const isCompleted = step < activeStep;
      const isActive = step === activeStep;
      return (
        <div
          key={label}
          onClick={() => {handleSelectActiveStep(step);  }}
          className={`flex flex-col items-center cursor-pointer flex-1 ${
            step === 1 ? "-ml-6" : step === steps.length ? "ml-6" : ""
          }`}
        >
          {/* Circle */}
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md border-2 transition-all duration-300 ${
              isCompleted
                ?  "bg-green-500 border-green-500 scale-110"
                : isActive
                ? "bg-white border-blue-700 shadow-lg scale-105"
                : "bg-white border-gray-300 hover:border-gray-400"
            }`}
          >
            {isCompleted ? (
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <span
                className={`font-bold text-sm ${
                isCompleted
  ? "text-green-600"
  : isActive
  ? "text-blue-600"
  : "text-gray-400"
                }`}
              >
                {step}
              </span>
            )}
          </div>

          {/* Label */}
          <p
            className={`mt-2 text-xs font-medium text-center transition-colors duration-300 ${
             isCompleted
  ? "text-green-600 font-semibold"
  : isActive
  ? "text-blue-600 font-semibold"
  : "text-gray-400"
            }`}
          >
            {label}
          </p>
        </div>
      );
    })}
  </div>
</div>




        {/* ================= STEP CONTENT (SINGLE CALL) ================= */}
  <RenderRFQStepContent
   activeStep = {activeStep}
   isStepLoading={isStepLoading}
  customerInfo = {customerInfo}
  rfqItemResponses = {rfqItemResponses}
  setShowPopup = {setShowPopup}
  setAssignPopupOpen = {setAssignPopupOpen}
  shipmentBlocks = {shipmentBlocks}
  addDeliveryShipment={addDeliveryShipment}
  suppliers= {suppliers}
  productCategories= {productCategories}
  selection ={selection}
  setSelection={setSelection}
  isCategoryFullySelected={isCategoryFullySelected}
  toggleCategorySelection={toggleCategorySelection}
  matrix={matrix}
  summary={summary}
   awardedItems={awardedItems}
  vehicles={vehicles}
  groups={groups}
  setGroups={setGroups}
  suppliersData={suppliersData}
  moveSupplier={moveSupplier}
  moveItem={moveItem}
  groupWeight={groupWeight}
  handleConfirm={handleConfirm}
  onConfirm={onConfirm}
  addGroup={addGroup}
  removeDeliveryShipment={removeDeliveryShipment}
  paymentDetails={paymentDetails}
  rfq = {customerInfo}
  onSuccessPayment={async () => {
  await getPaymentDetails();
  await triggerLeftRefresh();
}}
  finalRfqData = {finalRfqData}
  onOpenAssignSupplier={onOpenAssignSupplier}
  assignPopupOpen={assignPopupOpen}
   setSelectedItemId={setSelectedItemId} 
  setGroupToDelete={setGroupToDelete}
  setConfirmDeleteOpen={setConfirmDeleteOpen}
  openSupplierResponsePopup={openSupplierResponsePopup}
   setShowPopupMessages={setShowPopupMessages}
  setPopupMessage={setPopupMessage}
  setPopupType={setPopupType}
  setSelectedAlternatives={setSelectedAlternatives}
  fareLoading={fareLoading}
  setFareLoading={setFareLoading}
  />


      
</div>
<div className="sticky bottom-10 flex justify-end  pb-4 mr-2">
  <button
    onClick={goNext}
    disabled={isNextDisabled}
    className={`font-medium py-2 px-5 rounded-lg shadow-xl transition
      ${
        isNextDisabled
          ? "bg-gray-300 text-white cursor-not-allowed"
          : "bg-red-600 text-white hover:bg-red-700"
      }`}
  >
    Next
  </button>
</div>

       </>
    )}
  
      </div>

      <aside className="sticky top-[10px] h-[calc(100vh-73px)] w-80 border-l p-4">
          <ActionCenter onViewClick={triggerLeftRefresh} 
          onNewNotification={triggerLeftRefresh} />
        </aside>


       {showPopup && (
         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
           <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
             {/* Header */}
             <div className="flex justify-between items-center mb-4">
               <h4 className="font-semibold text-lg">Give BuildCoins</h4>
               <button
                 onClick={() => setShowPopup(false)}
                 className="text-gray-500 hover:text-gray-800"
               >
                 <X size={20} />
               </button>
             </div>
       
             {/* Input Field */}
             <div className="mb-4">
               <label className="block text-sm font-medium text-gray-700 mb-1">
                 Enter BuildCoins
               </label>
               <input
                 type="number"
                 min="0"
                 value={coinsToGive}
                 onChange={(e) => setCoinsToGive(e.target.value)}
                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                 placeholder="0"
               />
             </div>
       
             {/* Confirm Button */}
             <button
               type="button"
               className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow w-full disabled:opacity-50"
               onClick={handleGiveCoins}
               disabled={crediting || !coinsToGive}
             >
               {crediting ? 'Giving...' : 'Give'}
             </button>
           </div>
         </div>
       )}

       {showCreditResult && (
         <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
           <div className={`w-full max-w-sm rounded-lg p-4 shadow-xl ${creditResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
             <div className="flex items-start gap-3">
               <div className="mt-0.5">
                 {creditResult.success ? <CheckCircle className="text-green-600" /> : <X className="text-red-600" />}
               </div>
               <div className="flex-1">
                 <p className={`font-semibold ${creditResult.success ? 'text-green-800' : 'text-red-800'}`}>{creditResult.success ? 'Success' : 'Failed'}</p>
                 <p className="text-sm text-gray-700 mt-1">{creditResult.message}</p>
               </div>
             </div>
           </div>
         </div>
       )}
       
      
{assignPopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[999] p-4">
    <div className="bg-white w-full max-w-lg p-6 rounded-xl shadow-xl relative">
      <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
        <UserPlus className="mr-2 text-blue-600" size={20} />
        Assign Suppliers
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Select suppliers who can supply the items in this RFQ.
      </p>

      {/* Supplier List */}
      <div className="max-h-60 overflow-y-auto border rounded-lg p-3 bg-gray-50">
        {assignLoading ? (
          <div className="text-center py-6 text-gray-500">
            <Loader2 className="animate-spin mx-auto mb-2" />
            Loading suppliers...
          </div>
        ) : unassignedSuppliers.length === 0 ? ( // Changed to unassignedSuppliers
          <div className="text-center py-8">
             <p className="text-xs text-gray-400">No available suppliers found.</p>
          </div>
        ) : (
          unassignedSuppliers.map((s, idx) => ( // Changed to unassignedSuppliers
            <label
              key={s.vendor_id || idx}
              className="flex items-center p-2 border-b last:border-0 cursor-pointer hover:bg-blue-50 transition-colors"
            >
              <input
                type="checkbox"
                checked={selectedSuppliers.includes(s.vendor_id)}
                onChange={() => toggleSupplierSelection(s.vendor_id)}
                className="mr-3 h-4 w-4 text-blue-600"
              />
              <div>
                <p className="font-medium text-gray-800">
                  {s.vendor_details?.company_name || s.company_name || "Unknown Supplier"}
                </p>
                <p className="text-xs text-gray-500">
                  {s.items_count || 0} items | {s.vendor_details?.mobile_number || "No contact"}
                </p>
              </div>
            </label>
          ))
        )}
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-2 mt-5">
        <button
          className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
          onClick={() => {
            setAssignPopupOpen(false);
            setSelectedSuppliers([]); // Optional: clear selection on close
          }}
        >
          Cancel
        </button>

        <button
          onClick={() => selectedSuppliers.length > 0 && assignSelectedSuppliers()}
          disabled={selectedSuppliers.length === 0}
          className={`px-4 py-2 text-sm font-medium rounded-lg text-white transition-all ${
            selectedSuppliers.length === 0
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700 shadow-md active:scale-95"
          }`}
        >
          Assign {selectedSuppliers.length > 0 ? `(${selectedSuppliers.length})` : ''}
        </button>
      </div>
    </div>
  </div>
)}

{supplierResponsesPopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[999] p-4">
    <div className="bg-white w-full max-w-4xl rounded-xl shadow-2xl p-6 relative overflow-hidden">

      {/* Header */}
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h3 className="text-xl font-bold text-gray-900 flex items-center">
            <Package className="mr-2 text-blue-600" size={24} />
            Supplier Responses
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Responses for selected item
          </p>
        </div>

        <button
          className="text-gray-400 hover:text-red-500 rounded-full p-1"
          onClick={() => setSupplierResponsesPopupOpen(false)}
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </button>
      </div>

      {/* CONTENT */}
      {responsesLoading ? (
        <div className="flex justify-center items-center py-12 text-gray-500">
          <Loader2 className="animate-spin mr-2" />
          Fetching responses...
        </div>
      ) : filteredSuppliers.filter(res =>
          res.response_items?.some(
            ri => String(ri.item_id) === String(selectedItemId)
          )
        ).length === 0 ? (
        <div className="flex flex-col justify-center items-center py-12 text-gray-500">
          <Inbox size={40} className="mb-2" />
          <p>No suppliers responded for this item.</p>
        </div>
      ) : (
        <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">

          {/* 🔥 FILTERED SUPPLIERS ONLY */}
        {filteredSuppliers.map((res, i) => (
  <div key={i} className="border rounded-lg p-5 bg-white hover:bg-gray-50 transition">

    <div className="flex justify-between items-start mb-3">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
          <Building className="text-blue-600" size={20} />
        </div>
        <div>
          <p className="font-semibold">{res.vendor?.company_name}</p>
          <p className="text-sm text-gray-600">{res.vendor?.name}</p>

            <div className="flex items-center space-x-4 text-xs text-gray-600 mt-1">
                                <div className="flex items-center">
                                  <Phone className="mr-1" size={14} />
                                  {res?.vendor?.mobile}
                                </div>
                                <div className="flex items-center">
                                  <MapPin className="mr-1" size={14} />
                                  {res?.vendor?.address}
                                </div>
                                {/* <div className="flex items-center">
                                  <Truck className="mr-1" size={14} />
                                  {res?.delivered_by}
                                </div> */}
                              </div>
        </div>
      </div>

<div className="flex flex-col items-center space-y-2">
  <span
    className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
      res.response_status
    )}`}
  >
    {getStatusLabel(res.response_status)}
  </span>
</div>
    </div>

    {res.response_items.map((ri, idx) => (
      <div key={idx} className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-700 mt-3">
        <div className="flex items-center">
                         <Package className="mr-2 text-gray-500" size={16} />
                         <span className="font-medium">{ri.items_count} Items</span>
                       </div>
       
         <div className="flex items-center">
                          {/* <DollarSign className="mr-2 text-gray-500" size={16} /> */}
                          <span className="font-medium">₹{ri.total_price}</span>
                        </div>
        
        {/* <div>
          <span className="font-medium">Delivery</span>
          <p>{res.delivered_by}</p>
        </div> */}
        {/* <div>
          <span className="font-medium">Time Left</span>
          <p>{calculateRemainingTime(res.time_expired_at)}</p>
        </div> */}
      </div>
    ))}
  </div>
))}

        </div>
      )}
    </div>
  </div>
)}

{confirmDeleteOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[999]">
    <div className="bg-white rounded-lg p-6 w-80 shadow-lg text-center">

     <p className="text-md text-gray-900 text-center">
  Are you sure you want to delete this
</p>

<p className="text-md text-gray-900 text-center mt-1">
  Delivery Group <span className="font-bold">{groupToDelete}</span>?
</p>


      <div className="flex justify-center gap-4 mt-6">
        <button
          className="px-6 py-1.5 text-sm rounded-md font-medium border"
          onClick={() => {
            setConfirmDeleteOpen(false);
            setGroupToDelete(null);
          }}
        >
          No
        </button>

        <button
          className="px-6 py-1.5 text-sm rounded-md font-medium bg-red-600 text-white"
          onClick={() => {
            setGroups(prev =>
              prev.filter(g => g.groupId !== groupToDelete)
            );
            setConfirmDeleteOpen(false);
            setGroupToDelete(null);
          }}
        >
          Yes
        </button>
      </div>

    </div>
  </div>
)}


{showExtendPopup && selectedRFQ && (
        <ExtendTimePopup
          rfq={selectedRFQ}
          refresh={refresh}
          onClose={() => setShowExtendPopup(false)}
        />
      )}

      {showPopupMessages && (
        <div className=" z-[999]">
          {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
          {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
          {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
                {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
                {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
                {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
        </div>
      )}
    
    </div>
  );
};

export default RFQFullfillmentFlow;
